module.exports = __webpack_public_path__ + "img/IMG_6726_L_BlackMatted.b91c9c01.jpg";